<template>
  <div class="box">
    <div class="container">
      <div class="ai-text">
        <div class="ai-icon">
          <img :src="aiLoading" />
        </div>
        <span>AI 小助手为你分析生成中...</span>
      </div>
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script setup>
import aiLoading from '@/assets/analyse-icon.png'
</script>

<style lang="less" scoped>
.box {
  position: absolute;
  top: 4px;
  left: 4px;
  right: 4px;
  bottom: 4px;
  border-radius: 4px;
}
.ai-text {
  height: 44px;
  color: #c8c9cc;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0em;
  display: flex;
  flex-direction: row;
  align-items: center;
  .ai-icon {
    height: 20px;
    width: 20px;
    margin-right: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    color: #ffffff;
    background: linear-gradient(to bottom right, #0077ff, #2bb1ff);
  }
}
@property --roating {
  syntax: '<angle>';
  initial-value: 0deg;
  inherits: false;
}

@keyframes roating {
  0% {
    --roating: 0deg;
  }
  100% {
    --roating: 360deg;
  }
}
</style>
